export const READ_ALL_NOTIFICATION_START = 'READ_ALL_NOTIFICATION_START';

export const READ_ALL_NOTIFICATION_SUCCESS = 'READ_ALL_NOTIFICATION_SUCCESS';

export const READ_ALL_NOTIFICATION_FAILURE = 'READ_ALL_NOTIFICATION_FAILURE';
